import { NotFoundIcon } from '../../../assets/icons/icons';
import Popup from '../../Popup/Popup';
import './PromoCheckPopup.css';

function PromoCheckPopup({ isOpen, popupName, setOpen, promo }) {
    return (
        <Popup
            isOpen={isOpen}
            popupName={popupName}
            setOpen={setOpen}
        >
            <div className='promo-check-popup'>
                {promo.isValid ?
                    <>
                        <p className='promo-check-popup__discount'>-{Number(promo.discount).toLocaleString()}%</p>
                        <p className='promo-check-popup__text'>Promo-code <span className='promo-check-popup__text-string'>{promo.value}</span> for a discount {Number(promo.discount).toLocaleString()}% successfully applied to the order</p>
                    </>
                    :
                    <>
                        {/* <NotFoundIcon mainClassName={'promo-check-popup__invalid-icon'} fillClassName={'promo-check-popup__invalid-icon-fill'} /> */}
                        <p className='promo-check-popup__text'>Unfortunately, this promo code is no longer valid or does not exist.</p>
                    </>
                }

            </div>
        </Popup>

    );
}

export default PromoCheckPopup